import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import { trim, trimflags, isknr, issector } from '../../../utils';
import './Breadcrumbs.scss';
import * as API from '../../API';
export const Breadcrumbs = ({ className, light = false }) => {
    var _a, _b, _c, _d;
    const [currentHash, setCurrentHash] = useState(window.location.hash);
    const onNewUrl = () => {
        setCurrentHash(window.location.hash);
    };
    useEffect(() => {
        window.addEventListener('hashchange', onNewUrl);
    }, []);
    const wlh = currentHash.split('?')[0];
    const knr = (_b = (_a = /(kommuner|totalrangering|analyserommet)\/([0-5][0-9]+)/.exec(wlh)) === null || _a === void 0 ? void 0 : _a[2]) !== null && _b !== void 0 ? _b : null;
    const sec = (_d = (_c = /sektorer\/([a-z]{2,3})/.exec(wlh)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : null;
    const { data: lookupList } = useQuery(`kb/kodeliste`, API.fetchCodeList);
    const lookup = useRef(null);
    if (lookupList) {
        lookup.current = {
            kommune: lookupList.kommuner[knr !== null && knr !== void 0 ? knr : ''],
            sektor: lookupList.sektorer[sec !== null && sec !== void 0 ? sec : '']
        };
    }
    const recalc = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        const crumbsArr = [];
        let crumbCounter = 0;
        const firstCrumb = () => {
            return (_jsx("a", { href: "#hjem", className: "crumb home", children: _jsx("svg", { width: "13", height: "14", viewBox: "0 0 13 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { className: "house", d: "M8.55333 13.4667V10.0667C8.55333 9.31333 7.94 8.7 7.18667 8.7H5.46667C4.71333 8.7 4.1 9.31333 4.1 10.0667V13.4667H0V5.58667L6.32667 0L12.6533 5.58V13.46H8.55333V13.4667Z" }) }) }, `crumb_${crumbCounter++}`));
        };
        const innerCrumb = (href, title, className, crumbText) => {
            return (_jsx("a", { href: `${href}`, className: `crumb ${className}`, children: crumbText }, `crumb_${crumbCounter++}`));
        };
        const lastCrumb = (className, crumbText) => {
            return (_jsx("span", { className: `crumb ${className}`, children: crumbText }, `crumb_${crumbCounter++}`));
        };
        const browserPath = trim(currentHash.split('?')[0], '#', trimflags.TRIM_LEFT).split('/');
        browserPath.push(null); // End of path
        let index = 0;
        crumbsArr.push(firstCrumb());
        for (index = 0; index < browserPath.length; index++) {
            const item = browserPath[index];
            if (item !== null) {
                switch (item) {
                    case 'kommuner':
                        if (isknr((_a = browserPath[index + 1]) !== null && _a !== void 0 ? _a : '')) {
                            index++;
                            if (browserPath[index + 1]) {
                                crumbsArr.push(innerCrumb(`#kommuner/${knr}`, 'Kommuneforsiden', 'municipality', `${(_c = (_b = lookup === null || lookup === void 0 ? void 0 : lookup.current) === null || _b === void 0 ? void 0 : _b.kommune) !== null && _c !== void 0 ? _c : ''}`));
                            }
                            else {
                                crumbsArr.push(lastCrumb('Kommuneforsiden', `${(_e = (_d = lookup === null || lookup === void 0 ? void 0 : lookup.current) === null || _d === void 0 ? void 0 : _d.kommune) !== null && _e !== void 0 ? _e : ''}`));
                            }
                        }
                        break;
                    case 'sektorer':
                        if (issector((_f = browserPath[index + 1]) !== null && _f !== void 0 ? _f : '')) {
                            index++;
                            if (browserPath[index + 1]) {
                                crumbsArr.push(innerCrumb(`#kommuner/${knr}/sektorer/${sec}`, 'Sektorforsiden', 'sector', (_h = (_g = lookup === null || lookup === void 0 ? void 0 : lookup.current) === null || _g === void 0 ? void 0 : _g.sektor) !== null && _h !== void 0 ? _h : ''));
                            }
                            else {
                                crumbsArr.push(lastCrumb('Sektorforsiden', (_k = (_j = lookup === null || lookup === void 0 ? void 0 : lookup.current) === null || _j === void 0 ? void 0 : _j.sektor) !== null && _k !== void 0 ? _k : ''));
                            }
                        }
                        break;
                    case 'filarkiv':
                        if (browserPath[index + 1]) {
                            crumbsArr.push(innerCrumb(`#kommuner/${knr}/filarkiv`, 'Raporter og datafiler', 'file-archive', 'Filarkiv'));
                        }
                        else {
                            crumbsArr.push(lastCrumb('Raporter og datafiler', 'Filarkiv'));
                        }
                        break;
                    case 'totalrangering':
                        if (isknr((_l = browserPath[index + 1]) !== null && _l !== void 0 ? _l : '')) {
                            crumbsArr.push(innerCrumb(`#totalrangering`, 'Totalrangering, alle kommuner', 'total-ranking', 'Totalrangering'));
                            crumbsArr.push(lastCrumb(`Totalrangering, ${(_o = (_m = lookup === null || lookup === void 0 ? void 0 : lookup.current) === null || _m === void 0 ? void 0 : _m.kommune) !== null && _o !== void 0 ? _o : ''} kommune`, (_q = (_p = lookup === null || lookup === void 0 ? void 0 : lookup.current) === null || _p === void 0 ? void 0 : _p.kommune) !== null && _q !== void 0 ? _q : ''));
                        }
                        else {
                            crumbsArr.push(lastCrumb('Totalrangering, alle kommunene', 'Totalrangering'));
                        }
                        break;
                    case 'analyserommet':
                        if (isknr((_r = browserPath[index + 1]) !== null && _r !== void 0 ? _r : '')) {
                            crumbsArr.push(innerCrumb(`#analyserommet`, 'Analyserommet', 'analytics-room', 'Analyserommet'));
                            crumbsArr.push(lastCrumb('municipality', `${(_t = (_s = lookup === null || lookup === void 0 ? void 0 : lookup.current) === null || _s === void 0 ? void 0 : _s.kommune) !== null && _t !== void 0 ? _t : ''}`));
                        }
                        else {
                            switch ((_u = browserPath[index + 1]) !== null && _u !== void 0 ? _u : '') {
                                case 'kommunelister':
                                    crumbsArr.push(innerCrumb(`#analyserommet`, 'Analyserommet', 'analytics-room', 'Analyserommet'));
                                    crumbsArr.push(lastCrumb('municipality-lists', 'Kommunelister'));
                                    break;
                                case 'analyse':
                                    crumbsArr.push(innerCrumb(`#analyserommet`, 'Analyserommet', 'analytics-room', 'Analyserommet'));
                                    if (((_v = browserPath[index + 2]) !== null && _v !== void 0 ? _v : '') == 'ny') {
                                        crumbsArr.push(lastCrumb('analysis', 'Ny analyse'));
                                    }
                                    else {
                                        crumbsArr.push(lastCrumb('analysis', 'Rediger analyse'));
                                    }
                                    break;
                                default:
                                    crumbsArr.push(lastCrumb('analytics-room', 'Analyserommet'));
                            }
                        }
                        break;
                    case 'hjem':
                        ;
                        break;
                }
            }
        }
        return crumbsArr.toReversed();
    };
    const clsx = [
        light ? 'light-theme' : 'dark-theme',
        className !== null && className !== void 0 ? className : '',
        'breadcrumbs'
    ].join(' ');
    return (_jsx("nav", { className: clsx, children: recalc() }));
};
